import { inject, Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { JurisdictionsService } from './jurisdictions.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StoreService } from '../../store.service';


const BASE_URL = '/laws';

@Injectable({
  providedIn: 'root'
})
export class LawsService {

  accessToken: string = '';
  storeService: StoreService;
  httpClient: HttpClient;



  private laws = [
    {
      id: 3,
      jurisdiction: 'Ciudad Autonoma de Buenos Aires (LOTBA)',
      jurisdictionId: 6,
      name: "RESDI-2020-12-GCABA-LOTBA - Especificaciones tecnicas de juego, trazabilidad y transparencia",
      startDate: new Date(2023, 0, 10).toISOString().split('T')[0],
      endDate: new Date(2023, 1, 10).toISOString().split('T')[0],
      createTime: '10-01-2023'
    },
    {
      id: 1,
      jurisdiction: 'Italy',
      jurisdictionId: 1,
      name: "Gambling Act - Riigi Teataja - (In force from: 01.01.2021)",
      startDate: new Date(2022, 6, 19).toISOString().split('T')[0],
      endDate: new Date(2022, 6, 29).toISOString().split('T')[0],
      createTime: '19-06-2022'
    },
    {
      id: 14,
      jurisdiction: 'Spain',
      jurisdictionId: 19,
      name: "BOE-A-2011-17835-consolidado (RD_TEC)",
      startDate: new Date(2025, 6, 19).toISOString().split('T')[0],
      endDate: new Date(2025, 6, 29).toISOString().split('T')[0],
      createTime: '19-06-2025'
    },
    {
      id: 6,
      jurisdiction: 'Malta',
      jurisdictionId: 2,
      name: "Compliance Audit Manual - 08/2018",
      startDate: new Date(2025, 6, 19).toISOString().split('T')[0],
      endDate: new Date(2025, 6, 29).toISOString().split('T')[0],
      createTime: '19-06-2025'
    }
  ];

  private jurisdictionsSubject = new BehaviorSubject<string[]>([]);
  public jurisdictions$ = this.jurisdictionsSubject.asObservable();
  private isJurisdictionsLoaded = false;

  constructor(private jurisdictionsService: JurisdictionsService) {
    this.storeService = inject(StoreService);
    this.httpClient = inject(HttpClient);

    this.storeService.getAuthToken().subscribe(
      (data: any) => { this.accessToken = data ? data['accessToken'] : null }
    )
  }

  loadJurisdictions(): Observable<any> {
    if (this.isJurisdictionsLoaded) {
      return of(this.jurisdictionsSubject.value);
    }

    const params = new HttpParams().set('size', '9999');
    this.jurisdictionsService.list({ params }).subscribe({
      next: (response: any) => {
        const updatedJurisdictions = response.data.jurisdictions;
        this.jurisdictionsSubject.next(updatedJurisdictions);
        this.isJurisdictionsLoaded = true;
      },
      error: (error: any) => {
        console.error('Error fetching jurisdictions:', error);
      }
    });

    return this.jurisdictions$;
  }

  getJurisdictions(): Observable<any> {
    if (!this.isJurisdictionsLoaded) {
      return this.loadJurisdictions();
    }
    return this.jurisdictions$;
  }

  GET(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.get<any>(url, {
      headers,
      params
    });
  }

  POST(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.post<any>(url, data, {
      headers,
      params
    });
  }
  PUT(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.put<any>(url, data, {
      headers,
      params
    });
  }

  DELETE(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.delete<any>(url, {
      headers,
      params
    });
  }

  getUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`
  }







  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(lawId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${lawId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(lawId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${lawId}`), data);
  }

  delete(lawId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${lawId}`));
  }
}
